import React, { Suspense, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import RequireAuth from './common/guards/RequireAuth'
import { useDispatch } from 'react-redux'
import { loadAppSettings } from './store/app'
import Loader from './common/loader'
import { ErrorBoundary } from 'react-error-boundary'
import publicRoutes from './routes/publicRoutes'
import Page500 from './views/pages/page500/Page500'

const DefaultLayout = React.lazy(() =>
  import(/* webpackChunkName: "layout" */ './layout/DefaultLayout'),
)

const App = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(loadAppSettings())
  }, [dispatch])

  const renderPublicRoutes = () =>
    publicRoutes.map((route, idx) => {
      const Element = route.element
      return <Route key={idx} path={route.path} element={<Element />} />
    })

  return (
    <ErrorBoundary fallback={<Page500 />}>
      <Suspense fallback={<Loader />}>
        <Routes>
          {renderPublicRoutes()}
          <Route element={<RequireAuth />} name="Home">
            <Route path="/*" element={<DefaultLayout />} />
          </Route>
        </Routes>
      </Suspense>
    </ErrorBoundary>
  )
}

export default App
